import React, { Component } from "react";
import style from "./sidebar.module.css";
import userIcon from "../../assets/images/userico.png";
import { Link } from "react-router-dom";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visiblem: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
      setClass: false,
      visiblechef: false,
      visibleho: false,
      visiblepromo: false, 
      pathName: window.location.pathname,
      adminName: JSON.parse(sessionStorage.getItem("authData"))
        ? JSON.parse(sessionStorage.getItem("authData")).adminName
        : "",
      adminRole: JSON.parse(sessionStorage.getItem("authData"))
        ? JSON.parse(sessionStorage.getItem("authData")).adminRole
        : "",
      roleName: JSON.parse(sessionStorage.getItem("authData"))
        ? JSON.parse(sessionStorage.getItem("authData")).adminRole.roleName
        : "",
      rolePermissions: JSON.parse(sessionStorage.getItem("authData"))
        ? JSON.parse(sessionStorage.getItem("authData")).adminRole.permissions
        : "",
    };
    this.handClick = this.handClick.bind(this);
    this.handClickmaster = this.handClickmaster.bind(this);
    this.handClickadmin = this.handClickadmin.bind(this);
    this.handClickemailcustomer = this.handClickemailcustomer.bind(this);
    this.handClickfreesample = this.handClickfreesample.bind(this);
    this.handClickvendorhub = this.handClickvendorhub.bind(this);
    this.handClickchef = this.handClickchef.bind(this);
    this.handClickho = this.handClickho.bind(this);
    this.handClickpromo = this.handClickpromo.bind(this);
  }

  handClick() {
    this.setState((prevState) => ({ visible: !prevState.visible }));
    this.setState({
      visiblem: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
    });
  }
  handClickmaster() {
    this.setState((prevState) => ({
      visiblem: !prevState.visiblem,
    }));
    this.setState({
      visible: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
    });
  }

  handClickfreesample() {
    this.setState((prevState) => ({
      visiblefr: !prevState.visiblefr,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblemad: false,
      visibler: false,
    });
  }

  handClickadmin() {
    this.setState((prevState) => ({
      visiblemad: !prevState.visiblemad,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblefr: false,
      visibler: false,
    });
  }
  handClickemailcustomer() {
    this.setState((prevState) => ({
      visibler: !prevState.visibler,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblefr: false,
      visiblemad: false,
      visiblevendorhub: false,
    });
  }
  handClickvendorhub() {
    this.setState((prevState) => ({
      visiblevendorhub: !prevState.visiblevendorhub,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblefr: false,
      visiblemad: false,
      visibler: false,
    });
  }
  handClickchef() {
    this.setState((prevState) => ({
      visiblechef: !prevState.visiblechef,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
      visiblevendorhub: false,
    });
  }
  handClickho() {
    this.setState((prevState) => ({
      visibleho: !prevState.visibleho,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
      visiblechef: false,
      visiblevendorhub: false,
    });
  }
  handClickpromo() {
    this.setState((prevState) => ({
      visiblepromo: !prevState.visiblepromo,
    }));
    this.setState({
      visible: false,
      visiblem: false,
      visiblemad: false,
      visiblefr: false,
      visibler: false,
      visiblevendorhub: false,
      visiblechef: false,
      visibleho: false,
    });
  }
  handleAddClass = () => {
    this.setState((prevState) => ({
      setClass: !prevState.setClass,
    }));
  };

  logout(e) {
    sessionStorage.clear();
    window.location.href = "/";
  }
  componentDidMount() {
    this.getpathlist();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.pathName !== window.location.pathname) {
      this.setState({ pathName: window.location.pathname }, this.getpathlist);
    }
  }

  getpathlist() {
    const { pathName } = this.state;

    if (
      this.state.pathName === "/holiday" ||
      this.state.pathName === "/holiday/add/" ||
      this.state.pathName === "/settings" ||
      this.state.pathName === "/accountdetails" ||
      this.state.pathName === "/social-links" ||
      this.state.pathName === "/site-settings" ||
      this.state.pathName === "/notification" ||
      this.state.pathName === "/clearsession" ||
      this.state.pathName === "/allergens" ||
      this.state.pathName === "/allergens/add/" ||
      this.state.pathName ===
        `/allergens/edit/${this.state.pathName.split("/").at(-1)}` ||
      this.state.pathName === "/ingredients" ||
      this.state.pathName ===
        `/ingredients/edit/${this.state.pathName.split("/").at(-1)}` ||
      this.state.pathName === "/ingredients/add/" ||
      this.state.pathName === "/stripe-paymentkey" ||
      this.state.pathName === "/freecode" ||
      this.state.pathName === "/freecode/add/"
    ) {
      this.setState((prevState) => ({
        visible: !prevState.visible,
      }));
    }

    if (
      [
        `/master-entry/productgroup`,
        `/master-entry/add/productgroup`,
        `/master-entry/edit/productgroup/${pathName.split("/").at(-1)}`,
        `/master-entry/taxcode`,
        `/master-entry/add/taxcode`,
        `/master-entry/edit/taxcode/${pathName.split("/").at(-1)}`,
        `/master-entry/suitablefor`,
        `/master-entry/add/suitablefor`,
        `/master-entry/edit/suitablefor/${pathName.split("/").at(-1)}`,
        `/master-entry/sectors`,
        `/master-entry/add/sectors`,
        `/master-entry/edit/sectors/${pathName.split("/").at(-1)}`,
        `/depot`,
        `/depot/add`,
        `/depot/edit/${pathName.split("/").at(-1)}`,
        `/restrictedaccountcode/accountcode`,
        `/restrictedaccountcode/accountcode/add/`,
        `/restrictedaccountcode/accountcode/edit/${pathName.split("/").at(-2)}/`,
        `/masteraccountcode/accountcode`,
        `/masteraccountcode/accountcode/add/`,
        `/masteraccountcode/accountcode/edit/${pathName.split("/").at(-2)}/`,
        `/kitchenaccount`,
        `/kitchenaccount/add`,
        `/kitchenaccount/edit/${pathName.split("/").at(-2)}/`
      ].includes(pathName)
    ) {
      this.setState({ visiblem: true, visible: false });
    }

    if (
      [
        `/role`,
        `/role/editRoles/${this.state.pathName.split("/").at(-1)}`,
        `/account`,
      ].includes(pathName)
    ) {
      this.setState({ visiblemad: true, visible: false });
    }

    if (
      [
        `/freesample/freeorders`,
        `/freesample/freecode`,
        `/freesample/freecode/add/`,
        `/freesample/freecode/edit/${pathName.split("/").at(-1)}`,
      ].includes(pathName)
    ) {
      this.setState({ visiblefr: true, visible: false });
    }
    if (
      [
        `/email-configuration`,
        `/email-configuration/add`,
        `/email-configuration/edit`,
      ].includes(pathName)
    ) {
      this.setState({ visibler: true, visible: false });
    }
    if (
      [
        `/email-campaign`,
        `/email-campaign/add`,
        `/email-campaign/edit`,
      ].includes(pathName)
    ) {
      this.setState({ visibler: true, visible: false });
    }
    if (
      [
        `/vendorhub/faq`,
        `/vendorhub/faq/add`,
        `/vendorhub/faq/edit/${pathName.split("/").at(-1)}`,
        '/vendorhub/food-service-partner-lead-forms',
        '/vendorhub/food-service-partner-auth-email',
        '/vendorhub/food-service-partner',
      ].includes(pathName)
    ) {
      this.setState({ visiblevendorhub: true, visible: false });
    }
    if ([`/email-logs`].includes(pathName)) {
      this.setState({ visibler: true, visible: false });
    }
    if ([`/email-settings`].includes(pathName)) {
      this.setState({ visibler: true, visible: false });
    }
    if ([`/loggedinnotordered-emailcampaign`].includes(pathName)) {
      this.setState({ visibler: true, visible: false });
    }
    if ([`/abandonedcart-emailcampaign`].includes(pathName)) {
      this.setState({ visibler: true, visible: false });
    }
    if ([`/unsubscribed`].includes(pathName)) {
      this.setState({ visibler: true, visible: false });
    }
    if (
      [
        "/development-chef",
        "/development-chef/add",
        `/development-chef/edit/${pathName.split("/").at(-1)}`,
        "/chef/accountcode",
        "/chef/accountcode/add/",
        `/chef/accountcode/edit/${pathName.split("/").at(-2)}/`
      ].includes(pathName)
    ) {
      this.setState({ visiblechef: true, visible: false });
    }
    if (
      [
        "/headoffice/account",
        "/headoffice/account/add/",
        `/headoffice/account/edit/${pathName.split("/").at(-2)}/`,
        "/headoffice/accountcode",
        "/headoffice/accountcode/add/",
        `/headoffice/accountcode/edit/${pathName.split("/").at(-2)}/`,
      ].includes(pathName)
    ) {
      this.setState({ visibleho: true, visible: false });
    }
    if (
      [
        "/promooffers",
        "/promooffers/add",
        `/promooffers/edit/${pathName.split("/").at(-1)}`,
        "/promo-pinsa-settings",
        "/promooffers/feedback-form",
      ].includes(pathName)
    ) {
      this.setState({ visiblepromo: true, visible: false });
    }
  }

  render() {
    return (
      <>
        <div
          className={`${style.dashRight} ${this.state.setClass ? "open" : ""}`}
        >
          <div className={`${style.sideNav}`}>
            <div className={style.innside}>
              <div className={style.userIco}>
                <span>
                  <img src={userIcon} alt="user" />
                </span>
                {this.state.adminName && (
                  <h5 className={style.title}>{this.state.adminName}</h5>
                )}
              </div>
              <a className={style.menuOpen} onClick={this.handleAddClass}>
                <span>
                  <i className={`fa fa-angle-left`}></i>
                </span>
              </a>
              <nav>
                <ul>
                  {this.state.rolePermissions.includes("manage_dashboard") && (
                    <li
                      className={
                        this.state.pathName === "/dashboard" ? "active" : ""
                      }
                    >
                      <Link to="/dashboard">
                        <i className={`fa fa-th-large`}></i>{" "}
                        <span className={style.menuTxt}>Dashboard</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_products") && (
                    <li
                      className={
                        this.state.pathName === "/products" ? "active" : ""
                      }
                    >
                      {" "}
                      <Link to="/products">
                        <i className={`fa fa-archive`}></i>{" "}
                        <span className={style.menuTxt}>Products</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes(
                    "manage_freeproducts"
                  ) && (
                    <li
                      className={
                        this.state.pathName === "/freeproducts" ||
                        this.state.pathName ===
                          "/freeproducts/addfreeproducts" ||
                        this.state.pathName ===
                          `/freeproducts/editfreeproducts/${this.state.pathName
                            .split("/")
                            .at(-1)}`
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      <Link to="/freeproducts">
                        <i className={`fa fa-sliders`}></i>{" "}
                        <span className={style.menuTxt}>
                          Free Products Setup
                        </span>
                      </Link>
                    </li>
                  )}

                  {this.state.rolePermissions.includes(
                    "manage_newproducts"
                  ) && (
                    <li
                      className={
                        this.state.pathName === "/newproducts" ||
                        this.state.pathName === "/newproducts/add" ||
                        this.state.pathName ===
                          `/newproducts/edit/${this.state.pathName
                            .split("/")
                            .at(-1)}`
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      <Link to="/newproducts">
                        <i className={`fa fa-cube`}></i>{" "}
                        <span className={style.menuTxt}>New Products</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_promotions") && (
                    <li
                      className={
                        this.state.pathName === "/promotions" ||
                        this.state.pathName === "/promotions/add" ||
                        this.state.pathName ===
                          `/promotions/edit/${this.state.pathName
                            .split("/")
                            .at(-1)}`
                          ? "active"
                          : ""
                      }
                    >
                      <Link to="/promotions">
                        <i className={`fa fa-flag`}></i>{" "}
                        <span className={style.menuTxt}>Promotion Banner</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_promooffers") && (
                    <li
                      className={`${style.dropMenu} ${
                        this.state.visiblepromo ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={this.handClickpromo}>
                        <i className={`fa fa-gift`}></i>
                        <span className={style.menuTxt}>Promo Offers</span>
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          {/* Promo Offers */}
                          <li
                            className={
                              this.state.pathName === "/promooffers" ||
                              this.state.pathName === "/promooffers/add" ||
                              this.state.pathName ===
                                `/promooffers/edit/${this.state.pathName.split("/").at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/promooffers">
                              <i className={`fa fa-list-ul`}></i>
                              <span className={style.menuTxt}>Promo Offer Management</span>
                            </Link>
                          </li>
                          {/* Promo Offers Settings */}
                          <li
                            className={
                              this.state.pathName === "/promo-pinsa-settings"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/promo-pinsa-settings">
                              <i className={`fa fa-toggle-on`}></i>
                              <span className={style.menuTxt}>Promo Pinsa Email Settings</span>
                            </Link>
                          </li>
                          {/* Promo Feedback Form */}
                          <li
                            className={
                              this.state.pathName === "/promooffers/feedback-form"
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/promooffers/feedback-form">
                              <i className={`fa fa-comment`}></i>
                              <span className={style.menuTxt}>Promo Pinsa Email Template</span>
                            </Link>
                          </li>

                        </ul>
                      </div>
                    </li>
                  )}

                  {this.state.rolePermissions.includes("manage_customers") && (
                    <li
                      className={
                        this.state.pathName === "/vendors" ? "active" : ""
                      }
                    >
                      <Link to="/vendors">
                        <i className={`fa fa-users`}></i>{" "}
                        <span className={style.menuTxt}>Customers</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_vendorhub") && (
                    <>
                      <li
                        className={`${style.dropMenu} ${this.state.visiblevendorhub ? "active show" : ""
                          }`}
                      >
                        <a href={void 0} onClick={this.handClickvendorhub}>
                          <i className={` fa fa-hdd-o`}></i>{" "}
                          <span className={style.menuTxt}>Food Service Partner</span>{" "}
                          <i className="fa fa-angle-down"></i>
                        </a>
                        <div className={style.submenu}>
                          <ul>
                            <li
                              className={
                                this.state.pathName === "/vendorhub/food-service-partner-lead-forms"
                                  ? "active"
                                  : ""
                              }>
                              <Link to="/vendorhub/food-service-partner-lead-forms">
                                <i className={`fa fa-user-plus`}></i>{" "}
                                <span className={style.menuTxt}>Food Service Partner Lead Forms</span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/vendorhub/food-service-partner-auth-email"
                                  ? "active"
                                  : ""
                              }>
                              <Link to="/vendorhub/food-service-partner-auth-email">
                                <i className={`fa fa-check-circle`}></i>{" "}
                                <span className={style.menuTxt}>Food Service Partner Verification Email</span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/vendorhub/food-service-partner"
                                  ? "active"
                                  : ""
                              }>
                              <Link to="/vendorhub/food-service-partner">
                                <i className={`fa fa-briefcase`}></i>{" "}
                                <span className={style.menuTxt}>Food Service Partner - CMS Editor</span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/vendorhub/faq" ||
                                  this.state.pathName === "/vendorhub/faq/add" ||
                                  this.state.pathName ===
                                  `/vendorhub/faq/edit/${this.state.pathName
                                    .split("/")
                                    .at(-1)}`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/vendorhub/faq">
                                <i className={`fa fa-question-circle`}></i>{" "}
                                <span className={style.menuTxt}>FAQ Management</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </>
                  )}
                  {this.state.rolePermissions.includes("manage_orders") && (
                    <li
                      className={
                        this.state.pathName === "/orders" ? "active" : ""
                      }
                    >
                      <Link to="/orders">
                        <i className={`fa fa-shopping-cart`}></i>{" "}
                        <span className={style.menuTxt}>Orders</span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes(
                    "manage_foodsolutions"
                  ) && (
                    <>
                      <li
                        className={`${style.dropMenu} ${
                          this.state.visiblefr ? "active show" : ""
                        }`}
                      >
                        <a href={void 0} onClick={this.handClickfreesample}>
                          <i className={`fa fa-coffee`}></i>{" "}
                          <span className={style.menuTxt}>Food Solutions</span>{" "}
                          <i className="fa fa-angle-down"></i>
                        </a>
                        <div className={style.submenu}>
                          <ul>
                            <li
                              className={
                                this.state.pathName === "/freesample/freeorders"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/freesample/freeorders">
                                <i className={`fa fa-cart-arrow-down`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Free Sample Orders
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName ===
                                  "/freesample/freecode" ||
                                this.state.pathName ===
                                  "/freesample/freecode/add/" ||
                                this.state.pathName ===
                                  `/freesample/freecode/edit/${this.state.pathName
                                    .split("/")
                                    .at(-1)}`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/freesample/freecode">
                                <i className={`fa fa-address-book-o`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Free Sample Code
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </>
                  )}
                  {this.state.rolePermissions.includes("manage_stripelog") && (
                    <li
                      className={
                        this.state.pathName === "/stripe-paymentlog"
                          ? "active"
                          : ""
                      }
                    >
                      <Link to="/stripe-paymentlog">
                        <i className={`fa fa-cc-stripe`}></i>{" "}
                        <span className={style.menuTxt}>
                          Stripe Payment Log
                        </span>
                      </Link>
                    </li>
                  )}
                  {this.state.rolePermissions.includes(
                    "manage_masterentry"
                  ) && (
                    <li
                      className={`${style.dropMenu} ${
                        this.state.visiblem ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={this.handClickmaster}>
                        <i className={`fa fa-trophy`}></i>{" "}
                        <span className={style.menuTxt}>Master Entry </span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>

                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              this.state.pathName ===
                                "/master-entry/productgroup" ||
                              this.state.pathName ===
                                "/master-entry/add/productgroup" ||
                              this.state.pathName ===
                                `/master-entry/edit/productgroup/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/master-entry/productgroup">
                              <i className={`fa fa-database`}></i>{" "}
                              <span className={style.menuTxt}>
                                Product Group
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName === "/master-entry/taxcode" ||
                              this.state.pathName ===
                                "/master-entry/add/taxcode" ||
                              this.state.pathName ===
                                `/master-entry/edit/taxcode/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/master-entry/taxcode">
                              <i className={`fa fa-barcode`}></i>{" "}
                              <span className={style.menuTxt}>Tax Code</span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName ===
                                "/master-entry/suitablefor" ||
                              this.state.pathName ===
                                "/master-entry/add/suitablefor" ||
                              this.state.pathName ===
                                `/master-entry/edit/suitablefor/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/master-entry/suitablefor">
                              <i className={`fa fa-flag-o`}></i>{" "}
                              <span className={style.menuTxt}>
                                Suitable For
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName === "/master-entry/sectors" ||
                              this.state.pathName ===
                                "/master-entry/add/sectors" ||
                              this.state.pathName ===
                                `/master-entry/edit/sectors/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/master-entry/sectors">
                              <i className={`fa fa-industry`}></i>{" "}
                              <span className={style.menuTxt}>Sectors</span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName === "/depot" ||
                              this.state.pathName === "/depot/add" ||
                              this.state.pathName ===
                                `/depot/edit/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/depot">
                              <i className={`fa fa-map-marker`}></i>{" "}
                              <span className={style.menuTxt}>Depots</span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName ===
                                "/restrictedaccountcode/accountcode" ||
                              this.state.pathName ===
                                "/restrictedaccountcode/accountcode/add/" ||
                              this.state.pathName ===
                                `/restrictedaccountcode/accountcode/edit/${this.state.pathName
                                  .split("/")
                                  .at(-2)}/`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/restrictedaccountcode/accountcode">
                              <i className={`fa fa-lock`}></i>{" "}
                              <span className={style.menuTxt}>
                                Restricted Accounts
                              </span>
                            </Link>
                          </li>
                          <li
                              className={
                                this.state.pathName ===
                                  "/masteraccountcode/accountcode" ||
                                  this.state.pathName ===
                                  "/masteraccountcode/accountcode/add/" ||
                                  this.state.pathName ===
                                  `/masteraccountcode/accountcode/edit/${this.state.pathName
                                    .split("/")
                                    .at(-2)}/`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/masteraccountcode/accountcode">
                                <i className={`fa fa-shield`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Master Login Accounts
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === 
                                "/kitchenaccount" ||
                                this.state.pathName === 
                                "/kitchenaccount/add/" ||
                                this.state.pathName === 
                                `/kitchenaccount/edit/${this.state.pathName
                                    .split("/")
                                    .at(-2)}/`
                                ? "active"
                                : ""
                              }
                            >
                              <Link to="/kitchenaccount">
                                <i className={`fa fa-tags`}></i>{" "}
                                <span className={style.menuTxt}>Kitchen Accounts</span>
                              </Link>
                            </li>
                        </ul>
                      </div>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_chefs") && (
                    <li
                      className={`${style.dropMenu} ${
                        this.state.visiblechef ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={this.handClickchef}>
                        <i className="fa fa-cutlery"></i>
                        <span className={style.menuTxt}>Development Chef</span>
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              this.state.pathName === "/development-chef" ||
                              this.state.pathName === "/development-chef/add" ||
                              this.state.pathName ===
                                `/development-chef/edit/${this.state.pathName
                                  .split("/")
                                  .at(-1)}`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/development-chef">
                              <i className={`fa fa-user-circle`}></i>{" "}
                              <span className={style.menuTxt}>Chef Accounts</span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName === "/chef/accountcode" ||
                              this.state.pathName === "/chef/accountcode/add/" ||
                              this.state.pathName ===
                                `/chef/accountcode/edit/${this.state.pathName.split("/").at(-2)}/`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/chef/accountcode">
                              <i className="fa fa-user-secret"></i>
                              <span className={style.menuTxt}>
                                Restricted Chef Accounts
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}
                  {this.state.rolePermissions.includes("manage_ho") && (
                    <li
                      className={`${style.dropMenu} ${
                        this.state.visibleho ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={this.handClickho}>
                        <i className="fa fa-building"></i>
                        <span className={style.menuTxt}>Head Office</span>
                        <i className="fa fa-angle-down"></i>
                      </a>
                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              this.state.pathName === "/headoffice/account" ||
                              this.state.pathName === "/headoffice/account/add/" ||
                              this.state.pathName ===
                                `/headoffice/account/edit/${this.state.pathName
                                  .split("/")
                                  .at(-2)}/`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/headoffice/account">
                              <i className="fa fa-university"></i>
                              <span className={style.menuTxt}>
                                HO Accounts
                              </span>
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.pathName === "/headoffice/accountcode" ||
                              this.state.pathName === "/headoffice/accountcode/add/" ||
                              this.state.pathName ===
                                `/headoffice/accountcode/edit/${this.state.pathName
                                  .split("/")
                                  .at(-2)}/`
                                ? "active"
                                : ""
                            }
                          >
                            <Link to="/headoffice/accountcode">
                              <i className="fa fa-id-badge"></i>
                              <span className={style.menuTxt}>
                                Restricted HO Accounts
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}

                  {this.state.rolePermissions.includes("manage_users") && (
                    <li
                      className={`${style.dropMenu} ${
                        this.state.visiblemad ? "active show" : ""
                      }`}
                    >
                      <a href={void 0} onClick={this.handClickadmin}>
                        <i className={`fa fa-address-book`}></i>{" "}
                        <span className={style.menuTxt}>Admin Users </span>{" "}
                        <i className="fa fa-angle-down"></i>
                      </a>

                      <div className={style.submenu}>
                        <ul>
                          <li
                            className={
                              this.state.pathName === "/account" ? "active" : ""
                            }
                          >
                            <Link to="/account">
                              <i className={`fa fa-user-o`}></i>
                              <span className={style.menuTxt}>Users</span>
                            </Link>
                          </li>
                          {this.state.rolePermissions.includes(
                            "manage_roles"
                          ) && (
                            <li
                              className={
                                this.state.pathName === "/role" ||
                                this.state.pathName ===
                                  `/role/editRoles/${this.state.pathName
                                    .split("/")
                                    .at(-1)}`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/role">
                                <i className={`fa fa-level-up`}></i>
                                <span className={style.menuTxt}>Roles</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </li>
                  )}
                  {this.state.rolePermissions.includes(
                    "manage_emailcampaign"
                  ) && (
                    <>
                      <li
                        className={`${style.dropMenu} ${
                          this.state.visibler ? "active show" : ""
                        }`}
                      >
                        <a href={void 0} onClick={this.handClickemailcustomer}>
                          <i className={`fa fa-envelope`}></i>{" "}
                          <span className={style.menuTxt}>Email Campaign</span>{" "}
                          <i className="fa fa-angle-down"></i>
                        </a>
                        <div className={style.submenu}>
                          <ul>
                            {this.state.rolePermissions.includes(
                              "manage_emailcampaign"
                            ) && (
                              <li
                                className={
                                  this.state.pathName ===
                                    "/email-configuration" ||
                                  this.state.pathName ===
                                    "/email-configuration/add" ||
                                  this.state.pathName ===
                                    `/email-configuration/edit`
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to="/email-configuration">
                                  <i className={`fa fa-wrench`}></i>{" "}
                                  <span className={style.menuTxt}>
                                    Email Configurations
                                  </span>
                                </Link>
                              </li>
                            )}
                            {this.state.rolePermissions.includes(
                              "manage_emailcampaign"
                            ) && (
                              <li
                                className={
                                  this.state.pathName === "/email-campaign" ||
                                  this.state.pathName ===
                                    "/email-campaign/add" ||
                                  this.state.pathName === "/email-campaign/edit"
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to="/email-campaign">
                                  <i className="fa fa-calendar"></i>{" "}
                                  <span className={style.menuTxt}>
                                    Email Campaign Management
                                  </span>
                                </Link>
                              </li>
                            )}
                            {this.state.rolePermissions.includes(
                              "manage_emailcampaign"
                            ) && (
                              <li
                                className={
                                  this.state.pathName === "/email-logs"
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to="/email-logs">
                                  <i className={`fa fa-file-text-o`}></i>{" "}
                                  <span className={style.menuTxt}>
                                    Email Logs
                                  </span>
                                </Link>
                              </li>
                            )}
                            {this.state.rolePermissions.includes(
                              "manage_emailcampaign"
                            ) && (
                              <>
                                {/* <li className={this.state.pathName === "/loggedinnotordered-emailcampaign" ? "active" : ""}>
                                                                <Link to="/loggedinnotordered-emailcampaign"><i className="fa fa-exclamation-triangle"></i> <span className={style.menuTxt}>Logged In - Not Ordered</span></Link>
                                                            </li>
                                                            <li className={this.state.pathName === "/abandonedcart-emailcampaign" ? "active" : ""}>
                                                                <Link to="/abandonedcart-emailcampaign"><i className="fa fa-hourglass-half"></i> <span className={style.menuTxt}>Abandoned Cart</span></Link>
                                                            </li> */}
                                <li
                                  className={
                                    this.state.pathName === "/unsubscribed"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <Link to="/unsubscribed">
                                    <i className="fa fa-times-circle"></i>{" "}
                                    <span className={style.menuTxt}>
                                      Unsubscribed Customers
                                    </span>
                                  </Link>
                                </li>
                              </>
                            )}
                            {this.state.rolePermissions.includes(
                              "manage_emailcampaign"
                            ) && (
                              <li
                                className={
                                  this.state.pathName === "/email-settings"
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to="/email-settings">
                                  <i className={`fa fa-cogs`}></i>{" "}
                                  <span className={style.menuTxt}>
                                    Email Settings
                                  </span>
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      </li>
                    </>
                  )}

                  {this.state.rolePermissions.includes("manage_settings") && (
                    <>
                      <li
                        className={`${style.dropMenu} ${
                          this.state.visible ? "active show" : ""
                        }`}
                      >
                        <a href={void 0} onClick={this.handClick}>
                          <i className={`fa fa-gear`}></i>{" "}
                          <span className={style.menuTxt}>Settings</span>{" "}
                          <i className="fa fa-angle-down"></i>
                        </a>
                        <div className={style.submenu}>
                          <ul>
                            <li
                              className={
                                this.state.pathName === "/holiday" ||
                                this.state.pathName === "/holiday/add/"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/holiday">
                                <i className={`fa fa-calendar`}></i>{" "}
                                <span className={style.menuTxt}>Holidays</span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/settings"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/settings">
                                <i className={`fa fa-wrench`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Website Maintenance
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/allergens" ||
                                this.state.pathName === "/allergens/add/" ||
                                this.state.pathName ===
                                  `/allergens/edit/${this.state.pathName
                                    .split("/")
                                    .at(-1)}`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/allergens">
                                <i className={`fa fa-industry`}></i>{" "}
                                <span className={style.menuTxt}>Allergens</span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/ingredients" ||
                                this.state.pathName === "/ingredients/add/" ||
                                this.state.pathName ===
                                  `/ingredients/edit/${this.state.pathName
                                    .split("/")
                                    .at(-1)}`
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/ingredients">
                                <i className={`fa fa-magic`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Ingredients
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/stripe-paymentkey"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/stripe-paymentkey">
                                <i className={`fa fa-cc-stripe`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Stripe Payment Key
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/social-links"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/social-links">
                                <i className={`fa fa-globe`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Social Links
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/notification"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/notification">
                                <i className={`fa fa-bell`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Notification
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/clearsession"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/clearsession">
                                <i className={`fa fa-remove`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Delete Sessions
                                </span>
                              </Link>
                            </li>
                            <li
                              className={
                                this.state.pathName === "/site-settings"
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link to="/site-settings">
                                <i className={`fa fa-gear`}></i>{" "}
                                <span className={style.menuTxt}>
                                  Site Settings
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </>
                  )}

                  {/* <li className={(this.state.pathName==="/settings"?"active":"")}>
                                    <Link to="/settings"><i className={`fa fa-gear`}></i> Settings</Link>
                                </li>
                                
                                <li className={(this.state.pathName==="/holiday"?"active":"")}>
                                    <Link to="/holiday"><i className={`fa fa-calendar`}></i> Holidays</Link>
                                </li> */}

                  {/* <li className={`${style.dropMenu} ${this.state.visible ? 'show': ''}`}>
                                    <a href={void(0)} onClick={this.handClick}>SubMenu <i className="fa fa-angle-down"></i></a>
                                    <div className={style.submenu}>
                                        <ul>
                                            <li>
                                                <a href={void(0)}>SubMenu 1</a>
                                            </li>
                                            <li className="active">
                                                <a href={void(0)}>SubMenu 2</a>
                                            </li>
                                            <li>
                                                <a href={void(0)}>SubMenu 3</a>
                                            </li>
                                            <li>
                                                <a href={void(0)}>SubMenu 4</a>
                                            </li>
                                            <li>
                                                <a href={void(0)}>SubMenu 5</a>
                                            </li>
                                        </ul>
                                    </div>
                                </li> */}
                </ul>
              </nav>
              <div className={style.navBot}>
                <a href={void 0} onClick={(e) => this.logout(e)}>
                  <i className={`fa fa-sign-out`}></i>{" "}
                  <span className={style.menuTxt}>Logout</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Sidebar;
